import moment from 'moment';
import { i18n } from '../plugins/vuetify';

export default (date) => {
    const isTimestamp = typeof date === 'number';

    // is this a valid date?
    if ((isTimestamp && !moment.unix(date)._isValid) || (!isTimestamp && !moment(date)._isValid) || typeof date === 'undefined') {
        return '';
    }

    // german format
    if (i18n.locale === 'de') {
        return isTimestamp ? moment.unix(date).format('DD.MM.YYYY') : moment(date).format('DD.MM.YYYY');
    }

    // english format
    return isTimestamp ? moment.unix(date).format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD');
};
